/** -- external -- */
import React from "react";
import classNames from "classnames";

/** -- internal -- */
import { useI18n } from "Hooks";

/** -- relative -- */
import classes from "./ShortcutChip.scss";

import { getIsGlobalSearchJumpToRevampEnabled } from "GlobalHeader/modules/Utils";

const JUMP_TO_TRIGGER_KEY = "J";

const ShortcutChip = ({
  shortcutKey,
  shiftKey,
  addJumpToTriggerPrefix = false,
  isLearningCoursesFeed = false,
}) => {
  const { t } = useI18n(["common"]);
  const isGlobalSearchJumpToRevampEnabled = getIsGlobalSearchJumpToRevampEnabled();

  const shortcutKeyClass = isGlobalSearchJumpToRevampEnabled
    ? classes.shortcutKeyV2
    : classes.shortcutKey;

  const typographyClass = isGlobalSearchJumpToRevampEnabled
    ? "text-body-xs"
    : "text-body-3";

  return (
    <div
      className={classNames(
        {
          [classes.textDisabled]: addJumpToTriggerPrefix,
        },
        classes.container,
        typographyClass
      )}
    >
      {addJumpToTriggerPrefix && shortcutKey ? (
        <>
          <div className={shortcutKeyClass}>{JUMP_TO_TRIGGER_KEY}</div>
          {t("common:lowercase", {
            text: t("common:then"),
          })}
        </>
      ) : null}
      {shiftKey && (
        <>
          <div
            className={classNames(shortcutKeyClass, classes.shiftShortcutKey)}
          >
            Shift
          </div>
          +
        </>
      )}
      {isLearningCoursesFeed && (
        <>
          <div
            className={classNames(shortcutKeyClass, classes.shiftShortcutKey)}
          >
            C
          </div>
          +
        </>
      )}

      <div className={shortcutKeyClass}>{shortcutKey}</div>
    </div>
  );
};

export default ShortcutChip;
